import { create } from 'zustand';
import FormData from 'form-data';
import { createDI } from '../../../context/di/di';
import { ApiError, useApi } from '../../../api/api';
import { CsvUploadRequest } from '../../../model/csvupload_request';
import { SpreadSheetReponse } from '../../../model/spread_sheet_response';
import { DateTypeKeys } from '../../../constant';

/**
 * 作業計画一括投入画面 アクションを管理するための DI コンテキスト(アクション)
 */
export type TaskCsvAction = {
  /**
   * 作業計画登録
   * @param item
   * @param isDryRun
   */
  registeTaskCsv: (item: CsvUploadRequest, isDryRun?:boolean) => Promise<SpreadSheetReponse>;
};


/**
 * 作業計画一括投入画面 状態とアクションを管理するための DI コンテキストを作成
 */
const [Provider, use] = createDI<TaskCsvAction>();
export { Provider as TaskCsvProvider, use as useTaskCsvStore };

/**
 * 作業計画一括投入画面 状態とアクション
 */
export const defaultTaskCsvStore = () => {
  const api = useApi();

  return create<TaskCsvAction>(() => {
    return {
      registeTaskCsv: async (item: CsvUploadRequest, isDryRun:boolean = false) => {
        // FormDataに変換
        const form = new FormData();
        form.append('file', item.file);
        form.append('companyId', item.companyId);
        form.append('businessType', item.businessType);
        form.append('dataType', item.dataType);
        form.append('dateType', item.dateType);
        form.append('year', item.year);
        form.append('month', item.dateType === DateTypeKeys.yearly ? 0 : item.month);

        console.log('registeTaskCsv 開始');
        const ap = api.path(`/api/csv/upload${isDryRun ? '?dryRun=on' : ''}`)
          .noHeader();

        if (!isDryRun) {
          ap.skipTimeout();
        }

        const resp = await ap.post(form);
        if (resp.isError) {
          console.log('registeTaskCsv エラー');
          throw new ApiError(resp);
        }
        console.log(resp.data);
        console.log('registeTaskCsv 終了');

        return resp.data as SpreadSheetReponse;

      },
    };
  });
};
